import { axios, Response } from '../index'
import { GroupUsers } from './list-group-users'

export default async function listNonAdminGroupUsers(): Response<GroupUsers[]> {
  return await axios.get('/v1/profiles/drives')
}
